/*
  NDI Product page — buy-box interactions. Vanilla, no deps.
  - Thumbnail click swaps the main stage image.
  - Qty stepper +/- on the buy form.
  Add-to-cart itself is handled globally by ndi-cart-drawer's capture-phase interceptor
  (the form has data-ndi-cart-add), so there's nothing to wire here for that.
*/
(function () {
  function init(root) {
    // Special Order info box: tap toggles (mobile); desktop also gets CSS hover/focus.
    var so = root.querySelector('[data-ndi-pdp-so]');
    if (so) {
      var soBtn = so.querySelector('button');
      var setSo = function (open) { so.classList.toggle('is-open', open); soBtn.setAttribute('aria-expanded', open); };
      soBtn.addEventListener('click', function () { setSo(!so.classList.contains('is-open')); });
      document.addEventListener('click', function (e) { if (!so.contains(e.target)) setSo(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSo(false); });
    }

    // Thumb → stage swap
    var stage = root.querySelector('[data-ndi-pdp-stage] .ndi-pdp__stage-img');
    root.querySelectorAll('[data-ndi-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stage) {
          // use the full-res URL stored on the thumb (NOT the 160px thumb src — that's blurry)
          stage.src = btn.getAttribute('data-full-src') || stage.src;
          stage.srcset = btn.getAttribute('data-full-srcset') || '';
          stage.setAttribute('data-zoom-src', btn.getAttribute('data-zoom-src') || stage.src);
        }
        root.querySelectorAll('[data-ndi-pdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // Lightbox — click the stage image to open it large in a native dialog.
    // Prev/next walk the thumb rail; clicking the image (or the zoom button) toggles a
    // 2.5× scrollable zoom centred on the click point.
    var stageBox = root.querySelector('[data-ndi-pdp-stage]');
    var zoom = root.querySelector('[data-ndi-pdp-zoom]');
    if (stage && stageBox && zoom) {
      var zoomImg = zoom.querySelector('img');
      var view = zoom.querySelector('[data-ndi-pdp-zoom-view]');
      var zoomBtn = zoom.querySelector('[data-ndi-pdp-zoom-toggle]');
      var count = zoom.querySelector('[data-ndi-pdp-zoom-count]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ndi-pdp-thumb]'));
      var idx = 0;
      zoom.classList.toggle('is-single', thumbs.length < 2);

      function setZoom(on, e) {
        var r = zoomImg.getBoundingClientRect();
        // Pin the view to its unzoomed size so the box doesn't jump; the image scrolls inside it.
        view.style.width = on ? view.clientWidth + 'px' : '';
        view.style.height = on ? view.clientHeight + 'px' : '';
        zoomImg.style.width = on ? Math.max(zoomImg.naturalWidth, r.width * 2.5) + 'px' : '';
        zoom.classList.toggle('is-zoomed', on);
        zoomBtn.setAttribute('aria-pressed', on);
        zoomBtn.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in');
        if (!on) return;
        var fx = e ? (e.clientX - r.left) / r.width : 0.5;
        var fy = e ? (e.clientY - r.top) / r.height : 0.5;
        view.scrollLeft = fx * zoomImg.offsetWidth - view.clientWidth / 2;
        view.scrollTop = fy * zoomImg.offsetHeight - view.clientHeight / 2;
      }
      function show(i) {
        if (!thumbs.length) {
          zoomImg.src = stage.getAttribute('data-zoom-src') || stage.currentSrc;
          zoomImg.alt = stage.alt;
        } else {
          idx = (i + thumbs.length) % thumbs.length;
          zoomImg.src = thumbs[idx].getAttribute('data-zoom-src');
          zoomImg.alt = (thumbs[idx].querySelector('img') || stage).alt;
          count.textContent = (idx + 1) + ' / ' + thumbs.length;
        }
        setZoom(false);
      }

      stageBox.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return; // Save button lives in the stage
        show(Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('is-active'); })));
        zoom.showModal();
      });
      zoom.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-ndi-pdp-zoom-close]')) return zoom.close();
        if (t.closest('[data-ndi-pdp-zoom-prev]')) return show(idx - 1);
        if (t.closest('[data-ndi-pdp-zoom-next]')) return show(idx + 1);
        if (t.closest('[data-ndi-pdp-zoom-toggle]')) return setZoom(!zoom.classList.contains('is-zoomed'));
        // view, not just img: pointer capture retargets the click to the view
        if (view.contains(t)) return setZoom(!zoom.classList.contains('is-zoomed'), e);
        // true backdrop click = outside the dialog box
        var r = zoom.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) zoom.close();
      });
      // Drag: zoomed + mouse → pan (touch already scrolls natively); unzoomed → swipe prev/next.
      var drag = null, dragged = false;
      view.addEventListener('pointerdown', function (e) {
        drag = { x: e.clientX, y: e.clientY, sl: view.scrollLeft, st: view.scrollTop, zoomed: zoom.classList.contains('is-zoomed') };
        dragged = false;
        if (drag.zoomed && e.pointerType === 'mouse') { view.setPointerCapture(e.pointerId); e.preventDefault(); }
      });
      view.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) dragged = true;
        if (drag.zoomed && e.pointerType === 'mouse') { view.scrollLeft = drag.sl - dx; view.scrollTop = drag.st - dy; }
      });
      view.addEventListener('pointerup', function (e) {
        if (drag && !drag.zoomed && thumbs.length > 1) {
          var dx = e.clientX - drag.x;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(e.clientY - drag.y)) show(idx + (dx < 0 ? 1 : -1));
        }
        drag = null;
      });
      view.addEventListener('pointercancel', function () { drag = null; });
      // a drag must not also count as a click-to-zoom
      view.addEventListener('click', function (e) { if (dragged) { e.stopPropagation(); dragged = false; } }, true);

      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    // Qty steppers — there can be several (buy-box + sticky bar). Wire each independently.
    function clamp(n) { return isNaN(n) || n < 1 ? 1 : n; }
    root.querySelectorAll('[data-ndi-pdp-qty]').forEach(function (qty) {
      var input = qty.querySelector('[data-ndi-pdp-qty-input]');
      var minus = qty.querySelector('[data-ndi-pdp-minus]');
      var plus = qty.querySelector('[data-ndi-pdp-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10)); });
    });

    // Sticky buy bar — show only after the main buy-box has scrolled out of view.
    // Observe the hero with default viewport: visible while any part of the hero is on screen,
    // bar appears once it's fully scrolled past (above the top).
    var bar = root.querySelector('[data-ndi-pdp-stickybar]');
    var hero = root.querySelector('.ndi-pdp__hero');
    if (bar && hero && 'IntersectionObserver' in window) {
      var barIo = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // hero scrolled ABOVE the viewport (past it) → show bar. Below/visible → hide.
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        // lift floating widgets (LiveChat / ShopperApproved) above the bar while it's shown
        document.documentElement.classList.toggle('ndi-stickybar-open', scrolledPast);
      });
      barIo.observe(hero);
    }

    // Tab-nav: highlight the section currently in view (scrollspy).
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ndi-pdp-tab]'));
    if (tabs.length) {
      var targets = tabs
        .map(function (t) { return document.getElementById(t.getAttribute('href').slice(1)); })
        .filter(Boolean);
      if ('IntersectionObserver' in window && targets.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            tabs.forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('href') === '#' + e.target.id);
            });
          });
        }, { rootMargin: '-45% 0px -50% 0px' }); // fire when a section crosses the upper-middle
        targets.forEach(function (s) { io.observe(s); });
      }
    }
  }

  document.querySelectorAll('.ndi-pdp').forEach(init);
})();
